module.exports = __webpack_public_path__ + "static/img/footer.a11495e.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/footer.svg
// module id = CTAD
// module chunks = 0